const CONSTANTS = {
  CART_ACTIVE: 'CART:ACTIVATE',
  CART_MINICART: 'CART:MINICART',
  CART_MINICART_TOGGLE: 'CART:MINICART:TOGGLE',
  CART_UPDATE: 'CART:UPDATE',
  CART_ADD: 'CART:ADD',
  CART_FAIL: 'CART:FAIL',
  CART_REMOVEITEM: 'CART:REMOVEITEM',
  CART_CLEAR: 'CART:CLEAR',

  LOADING: 'LOADING',

  TOAST_DISPATCH: 'TOAST:DISPATCH',
  TOAST_SHOW: 'TOAST:SHOW',
  TOAST_HIDE: 'TOAST:HIDE',
  TOAST_DISMISS: 'TOAST:DISMISS',

  PORTALS: {
    LOADING: 'data-app-layer-portal="loading"',
    TOAST: 'data-app-layer-portal="toast"',
    CART_COUNT_BADGE: 'data-app-layer-portal="cart-count-badge"',
    PRODUCT_RECOMMENDATIONS: 'data-app-layer-portal="product-recommendations"',
    CART_RECOMMENDATIONS: 'data-app-layer-portal="cart-recommendations"',
  }
};

export default CONSTANTS;